import { Controller } from "@hotwired/stimulus"

// ファンドフォームで貸付を選んだとき、貸付の内容を各欄の既定値として流し込む。
// すでに値が入っている欄は上書きしない (管理者が入れた値を尊重する)。
//
//   募集総額   ← 貸付額
//   運用期間   ← 貸付期間 (月数)
//   運用開始日 ← 貸付日
export default class extends Controller {
  static targets = ["loan", "totalAmount", "operationPeriodMonths", "operationStartedOn"]
  static values = { url: String }

  async fill() {
    const loanId = this.loanTarget.value
    if (!loanId) return

    const response = await fetch(`${this.urlValue}/${loanId}.json`, {
      headers: { Accept: "application/json" },
    })
    if (!response.ok) return

    const loan = await response.json()

    this.setIfBlank(this.hasTotalAmountTarget && this.totalAmountTarget, loan.amount)
    this.setIfBlank(this.hasOperationPeriodMonthsTarget && this.operationPeriodMonthsTarget, loan.period_months)
    this.setIfBlank(this.hasOperationStartedOnTarget && this.operationStartedOnTarget, loan.started_on)
  }

  // 空欄のときだけ値を入れる。入れたあとは input を通知して、
  // カンマ整形 (comma-number) など他の controller が追随できるようにする。
  setIfBlank(element, value) {
    if (!element || value === null || value === undefined) return
    if (element.value.trim() !== "") return

    element.value = value
    element.dispatchEvent(new Event("input", { bubbles: true }))
  }
}
